import { render } from "./Title4.vue?vue&type=template&id=f6895e02"
import script from "./Title4.vue?vue&type=script&lang=ts"
export * from "./Title4.vue?vue&type=script&lang=ts"

import "./Title4.vue?vue&type=style&index=0&id=f6895e02&lang=scss"
script.render = render

export default script